export enum MimeFileType {
  Pdf = 'application/pdf',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}



// WEBPACK FOOTER //
// ./src/app/enums/mime-file-type.enum.ts